import type { ReactNode } from "react";
import { cx } from "../cx";
import { diffHunks, diffLines } from "./diff";

export function CodeView({ children }: { children: ReactNode }) {
  return <div className="sk-codeview">{children}</div>;
}
export function CodeLine({ n, kind, children }: { n: ReactNode; kind?: "add" | "del" | undefined; children: ReactNode }) {
  return <div className={cx("sk-ln", kind && `sk-ln--${kind}`)}><span className="sk-ln-n">{n}</span>{children}</div>;
}
/** Markdown-lite del método a las clases del sistema: #→mdh1, ##→mdh2, lista→mdli, **x**→mdem, >→fainted. */
export function methodSpan(line: string, key?: React.Key): ReactNode {
  const cls = line.startsWith("## ") ? "sk-mdh2" : line.startsWith("# ") ? "sk-mdh1" : /^\s*(\d+\.|[-*])\s/.test(line) ? "sk-mdli" : line.startsWith(">") ? "sk-fainted" : undefined;
  const parts = line.split(/\*\*([^*]+)\*\*/g).map((p, i) => (i % 2 ? <span className="sk-mdem" key={i}>{p}</span> : p));
  return <span className={cls} key={key}>{parts}</span>;
}
/** El método completo, línea a línea con numeración. */
export function MethodView({ text }: { text: string }) {
  return <CodeView>{text.split("\n").map((l, i) => <CodeLine n={i + 1} key={i}>{methodSpan(l)}</CodeLine>)}</CodeView>;
}
/** Diff real vA → vB, compactado a los cambios con contexto. */
export function MethodDiff({ a, b }: { a: string; b: string }) {
  const hunks = diffHunks(diffLines(a, b));
  return <CodeView>{hunks.map((l, i) => <CodeLine key={i} n={l.n} kind={l.kind === "same" ? undefined : l.kind}>{methodSpan(l.text)}</CodeLine>)}</CodeView>;
}
